export default __webpack_public_path__ + "static/media/testResults.fc5260c5.png";